export default __webpack_public_path__ + "static/media/reactlogo.55f6660b.png";